import React from 'react';
import { ProfilePage as CoreProfilePage } from '@byscott-io/corebyscott';

export default function ProfilePage() {
  return <CoreProfilePage />;
}
